import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentUser } from "../redux/slices/user/userSlice";
import {getAuthorization} from "../axios/AxiosAut";

function AccountRegistration() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const CurrentUser = useSelector((state) => state.user.currentUser);
  const getcurrentuser = () => {
    dispatch(getCurrentUser());
  };
  useEffect(() => {
    getcurrentuser();
  }, []);
  const handleActivecompany = (id) => {
    console.log("selected company", id);
    getAuthorization().patch(`users/set_active_company/`, {
      active_company: id,
    });
    Navigate("/dashboard");
  };
  return (
    <>
      <div className="container  w-3/4  mx-auto flex flex-col items-center ">
        <div className="flex justify-center items-center w-full space-y-8 flex-col">
          <div className="flex items-start flex-col">
            <div>
              <h2 className="mt-16 text-center font-Montserrat text-3xl font-bold text-black">
                Account Registeration
              </h2>
            </div>

            <div className="border-b-2 border-blue-200 w-28 "></div>
          </div>
          <div>
            <p className="text-center text-xs font-Montserrat font-semibold text-black">
              Select company you would like to log in to
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-5 my-16 md:grid-cols-2 sm:grid-cols-2">
          {CurrentUser.employed_in?.map((item, index) => (
            <div
              key={index}
              className="bg-white shadow-xl hover:scale-105 border-cyan-200 border-1 rounded-sm  hover:border-green align-middle  w-60 cursor-pointer "
              onClick={() => handleActivecompany(item.id)}
            >
              <div className="md:flex md:flex-col content-start items-center justify-items-start">
                <h2 className="font-medium mt-2 text-xl">
                  {item.company_name}
                </h2>
                <h1 className="text-blue-200">Production Engineer</h1>
                <div className="flex items-center my-3 ">
                  <h2 className="text-blue-200 text-3xl font-bold">${144}</h2>
                  <h1>/user</h1>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className=" my-4 text-center text-xs font-Montserrat font-semibold text-black">
          OR
        </p>
        <button
          onClick={() => {
            Navigate("/register-company");
          }}
          type="button"
          className="font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-1/2 rounded-sm px-4 py-2 flex flex-grow "
        >
          Register Company
        </button>
      </div>
    </>
  );
}

export default AccountRegistration;
